import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { copyTraining } from '../../../../../../../stores/trainings/trainings.actions'
import { getTraining } from '../../../../../../../stores/trainings/trainings.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id, history }) => {
  const file = getTraining(state, id)
  return {
    id: file.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onCopy: () => {
    return dispatch(copyTraining(ownProps.id)).then(() =>
      ownProps.history.push('/my-files')
    )
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContextMenu)
)
